import { render, staticRenderFns } from "./searchDic.vue?vue&type=template&id=76a0945c&scoped=true"
import script from "./searchDic.vue?vue&type=script&lang=js"
export * from "./searchDic.vue?vue&type=script&lang=js"
import style0 from "./searchDic.vue?vue&type=style&index=0&id=76a0945c&prod&scoped=true&lang=css"
import style1 from "./searchDic.vue?vue&type=style&index=1&id=76a0945c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76a0945c",
  null
  
)

export default component.exports